import { Link, useLocation } from 'react-router-dom';

export default function PaymentFailed() {
  const location = useLocation();
  const message = location.state?.error || 'Payment was not verified. Your clinic workspace has not been activated.';

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-3xl bg-white p-8 shadow-xl text-center">
        <div className="text-sm font-semibold uppercase tracking-[0.2em] text-rose-600">Payment not completed</div>
        <h1 className="mt-3 text-3xl font-bold text-slate-900">No workspace was created</h1>
        <p className="mt-3 text-slate-600">{message}</p>
        <Link to="/subscribe" className="mt-6 inline-flex rounded-2xl bg-indigo-600 px-5 py-3 font-semibold text-white">
          Retry subscription
        </Link>
      </div>
    </div>
  );
}
